import React from "react";

export type EntityType = "deal" | "event" | "notification";

const ENTITIES: { type: EntityType; label: string; enabled: boolean }[] = [
  { type: "deal", label: "Deal", enabled: true },
  { type: "event", label: "Event", enabled: false },
  { type: "notification", label: "Notification", enabled: false },
];

export function EntityRail({
  active, onSelect,
}: {
  active: EntityType;
  onSelect: (t: EntityType) => void;
}) {
  return (
    <div>
      <p className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider mb-2">New</p>
      <div className="space-y-1">
        {ENTITIES.map(e => (
          <button
            key={e.type}
            type="button"
            disabled={!e.enabled}
            onClick={() => e.enabled && onSelect(e.type)}
            className={`w-full flex items-center justify-between px-3 py-2 text-sm font-medium rounded-lg border transition-all ${
              active === e.type
                ? "bg-violet-950/40 border-violet-700 text-white"
                : e.enabled
                  ? "bg-gray-800 border-gray-700 text-gray-300 hover:border-gray-600"
                  : "bg-gray-800/40 border-gray-800 text-gray-600 cursor-not-allowed"
            }`}
          >
            {e.label}
            {!e.enabled && <span className="text-[10px] uppercase tracking-wide text-gray-600">soon</span>}
          </button>
        ))}
      </div>
    </div>
  );
}
